// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getUserId } from '~/core/state/user/selectors';

export const getAllCookies = (state: { cookies: typeof fromJS }) => state.cookies;
const getCookieKeyFromProps = (_: *, key: string): string => key;

export const getCookie = createSelector(
    getAllCookies,
    getUserId,
    getCookieKeyFromProps,
    (cookies, id, key) => cookies && cookies.get(`${id}-${key}`)
);



// WEBPACK FOOTER //
// ./src/core/state/cookies/selectors.js